import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
  ListItemText,
  Grid,
  ImageListItemBar
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useSelector, useDispatch } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import {
  FETCH_SITES,
  FETCH_SITE_TYPES,
  SAVE_SITES,
  SAVE_USER_SITES_PROJECTS,
  SAVE_POSTS,
  SAVE_POST_PICTURE
} from "../../constant/Apipath";
import Loader from "../../common/Loader";
import SearchMap from "../sites/SearchMap";
import {
  setSelectedProjectdata,
  setShowaddexperience,
  setSelectlocation,
  setSelectedsite
} from "../../redux/actions/actions";
import ImageIcon from "@mui/icons-material/Image";
import moment from "moment";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import { getAddress } from "../../request/Fetchcurrentaddress";
import { BIBlue } from "../../assets/helpers";
import SelectSite from "./SelectSite";
import { getFormattedAddress } from "./GetFormattedAddress";

const getFullAddress = (params) => {
  if (!params) return "";
  return getFormattedAddress(
    params.address || "",
    "",
    params.city || "",
    params.province || "",
    params.country || "",
    params.postalCode || "",
    3
  );
};

const SITES_PAGE_SIZE = 10;

const defaultAddressFields = {
  address: "",
  city: "",
  province: "",
  postalCode: "",
  country: "",
  lat: null,
  lng: null
};

const AddProjectFromMap = ({ open, onClose, onSuccess }) => {
  const { loginData, multiLanguageData, selectLocation } = useSelector((state) => state?.main);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [siteTypes, setSiteTypes] = useState([]);

  const [addressFields, setAddressFields] = useState({ ...defaultAddressFields });
  const [addressSearchTerm, setAddressSearchTerm] = useState("");
  const [siteCandidates, setSiteCandidates] = useState([]);
  const [siteSelectionModalOpen, setSiteSelectionModalOpen] = useState(false);
  const [siteNameInput, setSiteNameInput] = useState("");
  const [siteNameError, setSiteNameError] = useState("");
  const [pendingAddressForSite, setPendingAddressForSite] = useState(null);
  const [sitePage, setSitePage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [addNewSiteOpen, setAddNewSiteOpen] = useState(false);

  const [projectData, setProjectData] = useState({
    projectName: "",
    type: "",
    website: "",
    description: "",
    isActive: false,
    addToProfile: false
  });

  const [imagelist, setImagelist] = useState([]);
  const [checkingSites, setCheckingSites] = useState(false);
  const [errors, setErrors] = useState({});

  const {
    TEXT_ADD_PROJECT = "Add Project",
    TEXT_PROJECT_NAME = "Project Name",
    TEXT_TYPE = "Project Type",
    TEXT_WEBSITE = "Website",
    TEXT_DESCRIPTION = "Description",
    TEXT_ACTIVE_PROJECT = "Active Project",
    TEXT_ADD_TO_PROFILE = "Add to My Profile",
    TEXT_SAVE = "Save",
    TEXT_ADD_PICTURES = "Add Pictures",
    TEXT_SELECT_VALID_IMAGE = "Please select valid image files",
    TEXT_ENTER_VALID_URL_FORMAT = "Please enter a valid website URL",
    TEXT_SEARCH_ADDRESS = "Search Address *",
    TEXT_COUNTRY = "Country",
    TEXT_STREET_ADDRESS = "Street Address",
    TEXT_CITY = "City",
    TEXT_PROVINCE = "Province",
    TEXT_POSTAL_CODE = "Postal Code"
  } = multiLanguageData?.AddProject || {};

  const urlRegex =
    /^(https?:\/\/)?(www\.)?([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;

  useEffect(() => {
    if (open) {
      getSiteTypes();
    }
  }, [open]);

  useEffect(() => {
    const handleLocationSelected = async () => {
      if (
        selectLocation?.from === "addfrommap" &&
        !selectLocation?.open &&
        (selectLocation?.lat !== 0 || selectLocation?.lng !== 0)
      ) {
        const result = await getAddress({ lat: selectLocation.lat, lng: selectLocation.lng });
        if (result?.objAddress) {
          setAddressFields({
            address: result.objAddress.fullAddress || result.objAddress.address,
            city: result.objAddress.city,
            province: result.objAddress.province,
            postalCode: result.objAddress.postalCode,
            country: result.objAddress.country,
            lat: selectLocation.lat,
            lng: selectLocation.lng
          });
          setAddressSearchTerm(result.objAddress.fullAddress || result.objAddress.address);
          setErrors((prev) => ({ ...prev, site: "" }));
        }
      }
    };
    handleLocationSelected();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectLocation]);

  const getSiteTypes = async () => {
    try {
      setLoading(true);
      const payload = {
        PageNr: 1,
        NrOfRecPerPage: 0,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{}],
        SortList: [{ FieldName: "Name", Direction: "ASC" }]
      };
      const response = await Postrequestcall(FETCH_SITE_TYPES, payload, loginData?.accessToken);
      if (response.status === 200) {
        setSiteTypes(response?.data?.data ?? []);
      }
    } catch (error) {
      console.log("getSiteTypes-> Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    setProjectData({
      ...projectData,
      [name]: type === "checkbox" ? checked : value
    });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleAddressSelection = (place) => {
    if (!place) return;
    const lat = Number(place?.geometry?.location?.lat?.() ?? null);
    const lng = Number(place?.geometry?.location?.lng?.() ?? null);
    const formattedAddress = place?.formatted_address || "";
    const streetDetail = place?.streetDetail || place?.detailedLabel || formattedAddress;
    const city =
      place?.address_components?.find((addr) => addr.types.includes("locality"))?.long_name ??
      place?.address_components?.find((addr) => addr.types.includes("administrative_area_level_2"))
        ?.long_name ??
      "";
    const province =
      place?.address_components?.find((addr) => addr.types.includes("administrative_area_level_1"))
        ?.short_name ?? "";
    const postalCode =
      place?.address_components?.find((addr) => addr.types.includes("postal_code"))?.long_name ??
      "";
    const country =
      place?.address_components?.find((addr) => addr.types.includes("country"))?.long_name ?? "";
    setAddressFields({
      address: streetDetail,
      city,
      province,
      postalCode,
      country,
      lat,
      lng
    });
    setAddressSearchTerm(streetDetail);
    setErrors((prev) => ({ ...prev, site: "" }));
  };

  const handleAddressFieldChange = (field, value) => {
    setAddressFields((prev) => ({ ...prev, [field]: value }));
    if (errors.site) {
      setErrors((prev) => ({ ...prev, site: "" }));
    }
  };

  const openChooseLocationMap = () => {
    dispatch(
      setSelectlocation({
        open: true,
        lat: addressFields?.lat ?? 0,
        lng: addressFields?.lng ?? 0,
        from: "addfrommap"
      })
    );
  };

  const clearAddressDetails = () => {
    setAddressFields({ ...defaultAddressFields });
    setAddressSearchTerm("");
    setPendingAddressForSite(null);
    setSiteCandidates([]);
    setSiteSelectionModalOpen(false);
    setSiteNameInput("");
    setSiteNameError("");
    setErrors((prev) => ({ ...prev, site: "" }));
  };

  const fetchSitesForAddress = async (address, page = 1) => {
    try {
      const payload = {
        PageNr: page,
        NrOfRecPerPage: SITES_PAGE_SIZE,
        IncludeRecordNr: true,
        FullSearch: "",
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            City: address?.city,
            Province: address?.province,
            Address: address?.address,
            Country: address?.country,
            PostalCode: address?.postalCode
          }
        ]
      };
      const response = await Postrequestcall(FETCH_SITES, payload, loginData?.accessToken);
      if (response.status === 200) {
        return {
          data: response?.data?.data ?? [],
          totalRecords: response?.data?.recordsNr ?? 0
        };
      }
      return { data: [], totalRecords: 0 };
    } catch (error) {
      console.log("fetchSitesForAddress-> Error:", error);
      return { data: [], totalRecords: 0 };
    }
  };

  const handleSave = async () => {
    const newErrors = {};
    if (!projectData.projectName.trim()) newErrors.projectName = "Project name is required";
    if (!addressFields.address.trim()) newErrors.site = "Please provide a project address";
    if (projectData.website && !urlRegex.test(projectData.website)) {
      newErrors.website = TEXT_ENTER_VALID_URL_FORMAT;
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setCheckingSites(true);
    const addressSnapshot = { ...addressFields };
    setPendingAddressForSite(addressSnapshot);
    setSiteNameInput("");
    setSiteNameError("");
    setSitePage(1);
    setSiteCandidates([]);
    setAddNewSiteOpen(false);
    setHasMore(false);
    try {
      const result = await fetchSitesForAddress(addressFields, 1);
      if (result?.data?.length > 0) {
        setHasMore(true);
        setSitePage(2);
        setSiteCandidates(result?.data);
        setSiteSelectionModalOpen(true);
      } else {
        setHasMore(false);
        setSiteCandidates([]);
        setAddNewSiteOpen(true);
      }
    } catch (error) {
      console.log("handleSave-> Error:", error);
      alert("Failed to verify site.");
    } finally {
      setCheckingSites(false);
    }
  };

  const completeSaveWithSite = async (siteId, addressData) => {
    try {
      setSaving(true);
      const projectDetail = await createProject(siteId, addressData);
      if (imagelist?.length > 0 && projectDetail) {
        await saveProjectPictures(projectDetail);
      }
      if (projectData.addToProfile && projectDetail) {
        dispatch(
          setSelectedProjectdata({
            ...projectDetail,
            projectId: projectDetail?.id,
            type: "add",
            from: "select-option"
          })
        );
        if (localStorage.getItem("onboardingPending") !== "true") {
          dispatch(setShowaddexperience(true));
        } else {
          if (onSuccess) onSuccess();
        }
      } else {
        if (onSuccess) onSuccess();
      }
      handleClose();
    } catch (error) {
      console.log("completeSaveWithSite-> Error:", error);
      alert("Failed to save project.");
    } finally {
      setSaving(false);
    }
  };

  const handleSiteSelect = async (site) => {
    console.log("Site", site);
    dispatch(setSelectedsite(site));
    const addressToUse = pendingAddressForSite || addressFields;
    setSiteSelectionModalOpen(false);
    await completeSaveWithSite(site.id, addressToUse);
    setPendingAddressForSite(null);
  };

  const handleLoadMore = async () => {
    try {
      const result = await fetchSitesForAddress(pendingAddressForSite || addressFields, sitePage);
      if (result.data.length > 0) {
        setHasMore(true);
        setSitePage((prev) => prev + 1);
        setSiteCandidates((prev) => [...prev, ...result.data]);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.log("handleLoadMore-> Error:", error);
    }
  };

  const handleAddNewSiteConfirm = async () => {
    const trimmedName = siteNameInput.trim();
    if (!trimmedName) {
      setSiteNameError("Site name is required");
      return;
    }
    setSiteSelectionModalOpen(false);
    setAddNewSiteOpen(false);
    const addressToUse = pendingAddressForSite || addressFields;
    try {
      const siteId = await createNewSite(addressToUse, trimmedName);
      if (!siteId) throw new Error("Failed to create site");
      await completeSaveWithSite(siteId, addressToUse);
    } catch (error) {
      console.log("handleAddNewSiteConfirm-> Error:", error);
      alert("Failed to create site.");
    } finally {
      setPendingAddressForSite(null);
    }
  };

  const handleSitePickerClose = () => {
    setSiteSelectionModalOpen(false);
    setSiteCandidates([]);
    setSiteNameInput("");
    setSiteNameError("");
    setPendingAddressForSite(null);
    setAddNewSiteOpen(false);
    setHasMore(false);
    setSitePage(1);
  };

  const createNewSite = async (addressData, siteName) => {
    try {
      const payload = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            Name: siteName,
            Address: addressData?.address,
            City: addressData?.city,
            Province: addressData?.province,
            PostalCode: addressData?.postalCode,
            Country: addressData?.country,
            Latitude: addressData?.lat,
            Longitude: addressData?.lng,
            Active: true,
            RecordStatusId: 1,
            ModifiedBy: loginData?.userInformation?.UserId,
            WebSite: ""
          }
        ]
      };
      const response = await Postrequestcall(SAVE_SITES, payload, loginData?.accessToken);
      if (response.status === 201) {
        dispatch(setSelectedsite(response?.data?.data[0]?.objData));
        return response?.data?.data[0]?.objData?.id;
      }
    } catch (error) {
      console.log("createNewSite Error:", error);
      return null;
    }
  };

  const createProject = async (siteId, addressData) => {
    try {
      const payload = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            UserId: loginData?.userInformation?.UserId,
            SiteId: siteId,
            projectName: projectData.projectName,
            ProjectType: projectData.type || 0,
            ProjectWebsite: projectData.website,
            Description: projectData.description,
            IsActive: projectData.isActive,
            RecordStatusId: 1,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const response = await Postrequestcall(
        SAVE_USER_SITES_PROJECTS,
        payload,
        loginData?.accessToken
      );
      if (response.status === 201) {
        const projectDetail = response?.data?.data[0]?.objData;
        dispatch(
          setSelectedProjectdata({
            ...projectDetail,
            projectId: projectDetail?.id,
            siteName: projectDetail?.projectName,
            address: addressData?.address,
            city: addressData?.city,
            province: addressData?.province,
            postalCode: addressData?.postalCode,
            country: addressData?.country,
            latitude: addressData?.lat,
            longitude: addressData?.lng,
            type: "add"
          })
        );
        return projectDetail;
      } else {
        return null;
      }
    } catch (error) {
      throw error;
    }
  };

  const handleChooseFile = (event) => {
    const files = event.target.files;
    let allFilesValid = true;
    if (files?.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (!files[i].type.startsWith("image/")) {
          allFilesValid = false;
          break;
        }
      }
    }
    if (!allFilesValid) {
      return alert(`${TEXT_SELECT_VALID_IMAGE} (JPEG, PNG, GIF, etc.).`);
    }
    if (imagelist.length + files.length > 5) {
      return alert("You can only upload up to 5 images.");
    }
    let images = [];
    for (let i = 0; i < files?.length; i++) {
      images.push(files[i]);
    }
    setImagelist([...imagelist, ...images]);
    event.target.value = null;
  };

  const onDeletePicturePressed = (picItem, picIndex) => {
    let updatePicturesList = imagelist.filter((item, index) => index !== picIndex);
    setImagelist(updatePicturesList);
  };

  const saveProjectPictures = async (projectDetail) => {
    try {
      if (imagelist?.length > 0) {
        const getObj = {
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: true,
          ReturnRecordError: false,
          SaveList: [
            {
              Id: 0,
              FormatTypeId: 1,
              PostedByUserId: loginData?.userInformation?.UserId,
              AppId: 24,
              AppRecordId: projectDetail?.id,
              Message: "<<<picture>>>",
              Reported: false,
              ModifiedBy: loginData?.userInformation?.UserId
            }
          ]
        };
        const savePostResult = await Postrequestcall(SAVE_POSTS, getObj, loginData?.accessToken);
        if (savePostResult.status === 201) {
          let getId = savePostResult?.data?.data[0]?.objData?.id;
          await Promise.all(
            imagelist.map(async (item) => {
              let pictureDate = "";
              let fileDate = item?.file?.lastModifiedDate ?? null;
              if (fileDate) {
                pictureDate = moment(fileDate, "YYYY:MM:DD HH:mm:ss").format("YYYY-MM-DD hh:mm A");
              }
              const formData = new FormData();
              formData.append("Id", 0);
              formData.append("PostId", getId ?? 0);
              formData.append("ModifiedBy", loginData?.userInformation?.UserId);
              formData.append("Pictures", item);
              formData.append("PictureDateTime", pictureDate);
              formData.append("GPSLatitude", 0);
              formData.append("GPSLongitude", 0);
              formData.append("GPSAltitude", 0);
              await Fileuploadrequestcall(SAVE_POST_PICTURE, formData, loginData?.accessToken);
            })
          );
        }
      }
    } catch (error) {
      console.log("saveProjectPictures-> Error:", error);
    }
  };

  const handleClose = () => {
    setProjectData({
      projectName: "",
      type: "",
      website: "",
      description: "",
      isActive: false,
      addToProfile: false
    });
    setAddressFields({ ...defaultAddressFields });
    setAddressSearchTerm("");
    setSiteCandidates([]);
    setSiteSelectionModalOpen(false);
    setAddNewSiteOpen(false);
    setSiteNameInput("");
    setSiteNameError("");
    setPendingAddressForSite(null);
    setImagelist([]);
    setErrors({});
    setCheckingSites(false);
    onClose();
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        {saving ? (
          <Box sx={{ height: "450px" }}>
            <Loader />
          </Box>
        ) : (
          <Box
            className="user-modal-responsive"
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              maxHeight: "90vh",
              width: "95%",
              maxWidth: "600px",
              bgcolor: "background.paper",
              boxShadow: 24,
              display: "flex",
              flexDirection: "column",
              padding: "0px !important"
            }}>
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 2.5,
                borderBottom: "1px solid #f1f5f9",
                bgcolor: "white"
              }}>
              <Typography variant="h6" fontWeight={700}>
                {TEXT_ADD_PROJECT}
              </Typography>
              <IconButton onClick={handleClose} size="small">
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              sx={{
                p: 3,
                scrollbarWidth: "none",
                overflowY: "auto",
                flexGrow: 1,
                position: "relative"
              }}>
              {checkingSites && (
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    bgcolor: "rgba(255,255,255,0.8)",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                  <Loader />
                </Box>
              )}
              {loading && siteTypes.length === 0 ? (
                <Loader />
              ) : (
                <Stack spacing={2}>
                  {/* Images Upload */}
                  <Box>
                    <Typography variant="subtitle2" fontWeight={600} mb={1} color="text.secondary">
                      Photos
                    </Typography>
                    <Box
                      sx={{
                        border: "2px dashed #e2e8f0",
                        borderRadius: "10px",
                        p: 2,
                        bgcolor: "#f8fafc"
                      }}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{ overflowX: "auto", pb: 1, scrollbarWidth: "none" }}>
                        {imagelist.length < 5 && (
                          <Button
                            component="label"
                            sx={{
                              minWidth: 100,
                              height: 100,
                              flexShrink: 0,
                              borderRadius: "10px",
                              bgcolor: "white",
                              border: "1px solid #e2e8f0",
                              color: "#3b82f6",
                              flexDirection: "column",
                              gap: 1,
                              textTransform: "none",
                              "&:hover": { bgcolor: "#eff6ff", borderColor: "#3b82f6" }
                            }}>
                            <ImageIcon />
                            <Typography variant="caption" fontWeight={600}>
                              {TEXT_ADD_PICTURES}
                            </Typography>
                            <input
                              type="file"
                              multiple
                              accept="image/*"
                              onChange={handleChooseFile}
                              hidden
                            />
                          </Button>
                        )}

                        {imagelist.map((picItem, picIndex) => (
                          <Box
                            key={picIndex}
                            sx={{
                              position: "relative",
                              minWidth: 100,
                              height: 100,
                              flexShrink: 0,
                              borderRadius: "10px",
                              overflow: "hidden",
                              border: "1px solid #e2e8f0"
                            }}>
                            <img
                              src={URL.createObjectURL(picItem)}
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              alt={`Upload ${picIndex}`}
                            />
                            <ImageListItemBar
                              sx={{ background: "none", p: 0.5 }}
                              position="top"
                              actionIcon={
                                <IconButton
                                  size="small"
                                  onClick={() => onDeletePicturePressed(picItem, picIndex)}
                                  sx={{
                                    bgcolor: "rgba(0,0,0,0.5)",
                                    color: "white",
                                    "&:hover": { bgcolor: "rgba(0,0,0,0.7)" }
                                  }}>
                                  <CloseIcon sx={{ fontSize: 14 }} />
                                </IconButton>
                              }
                            />
                          </Box>
                        ))}
                      </Stack>
                    </Box>
                  </Box>

                  <TextField
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
                    label={TEXT_PROJECT_NAME}
                    name="projectName"
                    value={projectData.projectName}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    error={!!errors.projectName}
                    helperText={errors.projectName}
                  />

                  <Box
                    sx={{
                      "& .MuiOutlinedInput-root": { borderRadius: "10px", minHeight: "56px" }
                    }}>
                    <SearchMap
                      searchTerm={addressSearchTerm}
                      setSearchTerm={setAddressSearchTerm}
                      handleSearch={handleAddressSelection}
                      placeholder={TEXT_SEARCH_ADDRESS}
                      from="add-project"
                      useDetailedLabel
                      onClear={clearAddressDetails}
                    />
                    {errors.site && (
                      <Typography
                        variant="caption"
                        color="error"
                        sx={{ mt: 0.5, display: "block" }}>
                        {errors.site}
                      </Typography>
                    )}
                    <Typography
                      variant="body2"
                      sx={{ textAlign: "center", color: "#8d8d8d", my: 1 }}>
                      OR
                    </Typography>
                    <Button
                      variant="contained"
                      fullWidth
                      startIcon={<LocationOnIcon />}
                      sx={{ backgroundColor: "#083DB8", borderRadius: "8px", py: 1.5 }}
                      onClick={openChooseLocationMap}>
                      Choose location on map
                    </Button>

                    {addressFields.address && (
                      <Grid container spacing={2} mt={2.5}>
                        <Grid size={6}>
                          <TextField
                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
                            label={TEXT_STREET_ADDRESS}
                            value={addressFields.address}
                            onChange={(e) => handleAddressFieldChange("address", e.target.value)}
                            fullWidth
                          />
                        </Grid>
                        <Grid size={6}>
                          <TextField
                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
                            label={TEXT_CITY}
                            value={addressFields.city}
                            onChange={(e) => handleAddressFieldChange("city", e.target.value)}
                            fullWidth
                          />
                        </Grid>
                        <Grid size={6}>
                          <TextField
                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
                            label={TEXT_PROVINCE}
                            value={addressFields.province}
                            onChange={(e) => handleAddressFieldChange("province", e.target.value)}
                            fullWidth
                          />
                        </Grid>
                        <Grid size={6}>
                          <TextField
                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
                            label={TEXT_POSTAL_CODE}
                            value={addressFields.postalCode}
                            onChange={(e) => handleAddressFieldChange("postalCode", e.target.value)}
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                    )}
                  </Box>
                  <FormControl
                    fullWidth
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}>
                    <InputLabel>{TEXT_TYPE}</InputLabel>
                    <Select
                      name="type"
                      value={projectData.type}
                      onChange={handleInputChange}
                      label={TEXT_TYPE}>
                      {siteTypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>
                          <ListItemText primary={type.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
                    label={TEXT_WEBSITE}
                    name="website"
                    value={projectData.website}
                    onChange={handleInputChange}
                    fullWidth
                    error={!!errors.website}
                    helperText={errors.website}
                  />

                  <TextField
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
                    label={TEXT_DESCRIPTION}
                    name="description"
                    value={projectData.description}
                    onChange={handleInputChange}
                    fullWidth
                    multiline
                    rows={3}
                  />

                  <Stack direction="row" spacing={2}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="isActive"
                          checked={projectData.isActive}
                          onChange={handleInputChange}
                          color="primary"
                        />
                      }
                      label={TEXT_ACTIVE_PROJECT}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="addToProfile"
                          checked={projectData.addToProfile}
                          onChange={handleInputChange}
                          color="primary"
                        />
                      }
                      label={TEXT_ADD_TO_PROFILE}
                    />
                  </Stack>
                </Stack>
              )}
            </Box>

            <Box sx={{ p: 3, borderTop: "1px solid #f1f5f9", bgcolor: "white" }}>
              <Button
                variant="contained"
                onClick={handleSave}
                fullWidth
                loading={saving}
                disabled={
                  saving || checkingSites || !projectData.projectName || !addressFields.address
                }
                sx={{
                  borderRadius: "10px",
                  py: 1,
                  fontSize: "1rem",
                  fontWeight: 700,
                  textTransform: "none",
                  bgcolor: "#3b82f6",
                  "&:hover": { bgcolor: BIBlue },
                  minHeight: "44px" // Maintain height during loading
                }}>
                {TEXT_SAVE}
              </Button>
            </Box>
          </Box>
        )}
      </Modal>

      <SelectSite
        open={siteSelectionModalOpen}
        onClose={handleSitePickerClose}
        address={pendingAddressForSite || addressFields}
        siteCandidates={siteCandidates}
        hasMore={hasMore}
        onSiteSelect={handleSiteSelect}
        onLoadMore={handleLoadMore}
        onAddNewOpen={() => {
          setAddNewSiteOpen(true);
          setSiteNameInput("");
          setSiteNameError("");
        }}
      />

      {/* Standalone Add Site Name popup */}
      <Modal
        open={addNewSiteOpen}
        onClose={() => {
          setAddNewSiteOpen(false);
          setSiteNameInput("");
          setSiteNameError("");
        }}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: 500,
            bgcolor: "background.paper",
            borderRadius: "16px",
            boxShadow: 24,
            p: 3
          }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6" fontWeight={700}>
              Add Site Name
            </Typography>
            <IconButton
              onClick={() => {
                setAddNewSiteOpen(false);
                setSiteNameInput("");
                setSiteNameError("");
              }}
              size="small">
              <CloseIcon />
            </IconButton>
          </Stack>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              bgcolor: "#EEF2FF",
              borderRadius: "12px",
              px: 2,
              py: 1.5,
              gap: 1,
              mb: 2.5
            }}>
            <LocationOnIcon sx={{ color: "#083DB8", fontSize: 20, flexShrink: 0 }} />
            <Typography variant="body2" fontWeight={600} color="#083DB8" noWrap>
              {getFullAddress(pendingAddressForSite || addressFields)}
            </Typography>
          </Box>

          <Typography
            variant="caption"
            sx={{
              display: "block",
              mb: 1,
              color: "text.secondary",
              letterSpacing: "0.08em",
              fontWeight: 600
            }}>
            SITE NAME
          </Typography>
          <TextField
            fullWidth
            placeholder="Enter site name"
            value={siteNameInput}
            onChange={(e) => {
              setSiteNameInput(e.target.value);
              setSiteNameError("");
            }}
            autoFocus
            error={!!siteNameError}
            helperText={siteNameError}
            sx={{ mb: 3, "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
          />

          <Stack direction="row" spacing={2}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                setAddNewSiteOpen(false);
                setSiteNameInput("");
                setSiteNameError("");
              }}
              sx={{
                borderRadius: "12px",
                py: 1.5,
                bgcolor: "#e0e0e0",
                color: "#333",
                boxShadow: "none",
                "&:hover": { bgcolor: "#d0d0d0", boxShadow: "none" },
                textTransform: "none",
                fontWeight: 700,
                fontSize: "1rem"
              }}>
              Cancel
            </Button>
            <Button
              fullWidth
              variant="contained"
              onClick={handleAddNewSiteConfirm}
              disabled={!siteNameInput.trim()}
              sx={{
                borderRadius: "12px",
                py: 1.5,
                bgcolor: siteNameInput.trim() ? "#083DB8" : "#e0e0e0",
                "&:hover": { bgcolor: siteNameInput.trim() ? BIBlue : "#e0e0e0" },
                "&.Mui-disabled": { bgcolor: "#e0e0e0", color: "#aaa" },
                textTransform: "none",
                fontWeight: 700,
                fontSize: "1rem"
              }}>
              Continue
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default AddProjectFromMap;
